import React from 'react';
import {BaseMixin, ElementaryMixin, Tools} from './../common/common.js';

import InputWrapper from './internal/input-wrapper.js';
import TextInput from './internal/text-input.js';

import TextInputMixin from './mixins/text-input-mixin.js'

import ItemList from './internal/item-list.js';
import Backdrop from './../bricks/backdrop.js';

import './number.less';

export const Number = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    TextInputMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Forms.Number',
    classNames: {
      main: 'uu5-forms-number'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    value: React.PropTypes.oneOfType([
      React.PropTypes.number,
      React.PropTypes.string
    ]),
    step: React.PropTypes.number,
    min: React.PropTypes.number,
    max: React.PropTypes.number,
    decimals: React.PropTypes.number,
    decimalSeparator: React.PropTypes.string,
    thousandSeparator: React.PropTypes.string,
    rounded: React.PropTypes.bool,
    nanMessage: React.PropTypes.any,
    lowerMessage: React.PropTypes.any,
    upperMessage: React.PropTypes.any,
    buttonHidden: React.PropTypes.bool
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps () {
    return {
      value: null,
      step: 1,
      min: null,
      max: null,
      decimals: null,
      decimalSeparator: ',',
      thousandSeparator: null,
      rounded: false,
      nanMessage: 'Please insert a number',
      lowerMessage: 'Please type in bigger number.',
      upperMessage: 'Please type in smaller number.',
      buttonHidden: false
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle


  componentWillMount(){
    if (this.props.onValidate && typeof this.props.onValidate === 'function') {
      let result = this._setNumberResult({value: this.state.value});
      if (result) {
        if (typeof result === 'object') {
          if (result.feedback) {
            this.setFeedback(result.feedback, result.message, result.value);
          } else {
            this._validateOnChange({value: this.state.value, event: null, component: this})
          }
        }
      }
    } else {
      this.setInitial(null, this.state.value)
    }
    return this;
  },

  componentWillReceiveProps(nextProps) {
    if (this.props.controlled) {
      let result = this._setNumberResult({value: nextProps.value});
      if (result) {
        if (typeof result === 'object') {
          if (result.feedback) {
            this.setFeedback(result.feedback, result.message, result.value);
          } else {
            this.setFeedback(nextProps.feedback, nextProps.message, nextProps.value)
          }
        }
      }
    }
    return this;
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface


  //@@viewOff:interface

  //@@viewOn:overridingMethods
  // TODO: tohle je ještě otázka - je potřeba nastavit hodnotu z jiné komponenty (musí být validace) a z onChange (neměla by být validace)
  setValue_(value, setStateCallback){
    if (this._checkRequired(value)) {
      if (typeof this.props.onValidate === 'function') {
        this._validateOnChange({value: value, event: null, component: this});
      } else {
        this.props.required ? this.setSuccess(null, value, setStateCallback) : this.setInitial(null, value, setStateCallback);
      }
    }

    return this;
  },
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _checkNumberResultChange(opt){
    if (opt.value) {
      opt.value = opt.value.toString();
      let isComma = opt.value.indexOf(',') > 0;

      opt.value = opt.value.trim().replace(new RegExp(this.props.thousandSeparator, 'g'), '');
      opt.value = opt.value.replace(',', '.');
      let isNan = isNaN(opt.value);

      if (isNan && opt.value != '-') {
        opt.value = this.state.value;
        opt.feedback = 'warning';
        opt.message = this.props.nanMessage;
      }

      isComma && (opt.value = opt.value.replace('.', ','));

    }
    return opt;
  },

  _checkNumberResult(opt){
    if (opt.value) {
      opt = this._checkNumberResultChange(opt);
      let isComma = opt.value && opt.value.indexOf(',') > 0;

      opt.value = opt.value.replace(new RegExp(this.props.thousandSeparator, 'g'), '');
      opt.value = opt.value.replace(',', '.');

      let number = parseFloat(opt.value);

      if (this.props.min && number < this.props.min) {
        opt.value = this.props.min.toString();
        opt.feedback = 'error';
        opt.message = this.props.lowerMessage;
      }

      if (this.props.max && number > this.props.max) {
        opt.value = this.props.max.toString();
        opt.feedback = 'error';
        opt.message = this.props.upperMessage;
      }

      isComma && (opt.value = opt.value.replace('.', ','));

    }
    return opt;
  },

  _setNumberResult(opt){
    let result = this._checkNumberResult(opt);
    if (opt.value) {
      let number = opt.value.replace(this.props.decimalSeparator, '.').replace(',', '.');

      if (this.props.rounded && number) {
        let exp = this.props.decimals ? -1 * this.props.decimals : 0;
        number = Tools.round10(parseFloat(number), exp).toString();
      }

      let numberParts = number.split('.');

      if (this.props.thousandSeparator) {
        numberParts[0] = numberParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.props.thousandSeparator);
      }
      if (numberParts.length > 1) {
        if (this.props.decimals && this.props.decimals < numberParts[1].length) {
          numberParts[1] = numberParts[1].slice(0, this.props.decimals - numberParts[1].length);
        }
        result.value = numberParts[0] + this.props.decimalSeparator + numberParts[1];
      } else {
        result.value = numberParts[0];
      }
    }
    return result;
  },

  _onChange(e){
    let opt = {value: e.target.value, event: e, component: this};
    let checkNumberResult = this._checkNumberResultChange(opt);

    if (checkNumberResult.feedback && checkNumberResult.feedback === 'warning') {
      this.setFeedback(checkNumberResult.feedback, checkNumberResult.message, checkNumberResult.value);
    } else {
      if (!this.isDisabled() && !this.isReadOnly()) {
        if (typeof this.props.onChange === 'function') {
          this.props.onChange(opt);
        } else {
          if (this.props.validateOnChange) {
            this._validateOnChange(opt);
          } else {
            if (this._checkRequired({value: opt.value})) {
              opt.required = this.props.required;
              let result = this.getChangeFeedback(opt);
              this.setFeedback(result.feedback, result.message, result.value);
            }
          }
        }
      }
    }

    return this;
  },

  _onBlur(e){
    let opt = {value: e.target.value, event: e, component: this};

    if (typeof this.props.onBlur === 'function') {
      this.props.onBlur(opt);
    } else {
      let blurResult = this.getBlurFeedback(opt);
      let setNumberResult = this._setNumberResult(blurResult);
      if (this._checkRequired({value: setNumberResult.value}) && !this.props.validateOnChange) {
        setNumberResult.required = this.props.required;
        if (setNumberResult.feedback && setNumberResult.feedback) {
          this.setFeedback(setNumberResult.feedback, setNumberResult.message, setNumberResult.value);
        }
      } else {
        this.setFeedback(setNumberResult.feedback, setNumberResult.message, setNumberResult.value);
      }
    }

    return this;
  },

  _onFocus(e){
    let opt = {value: e.target.value, event: e, component: this};
    if (typeof this.props.onFocus === 'function') {
      this.props.onFocus(opt);
    } else {
      let result = this.getFocusFeedback(opt);
      if (result) {
        this.setFeedback(result.feedback, result.message, result.value)
      } else {
        this.setFeedback(null, null, this.state.value.replace(new RegExp(this.props.thousandSeparator, 'g'), ''));
      }
    }

    return this;
  },


  _validateOnChange(opt){
    let result = typeof this.props.onValidate === 'function' ? this.props.onValidate(opt) : null;
    if (result) {
      if (typeof result === 'object') {
        if (result.feedback) {
          this.setFeedback(result.feedback, result.message, result.value);
        } else {
          this.setState({value: opt.value});
        }
      } else {
        this.showError('validateError', null, {context: {event: e, func: this.props.onValidate, result: result}});
      }
    }
    return this;
  },

  _getFeedbackIcon(){
    let icon = this.props.required ? this.props.successGlyphicon : null;
    switch (this.getFeedback()) {
      case 'success':
        icon = this.props.successGlyphicon;
        break;
      case 'warning':
        icon = this.props.warningGlyphicon;
        break;
      case 'error':
        icon = this.props.errorGlyphicon;
        break;
    }
    return icon;
  },

  _decrease(){
    //TODO: optimize
    let value = this.state.value || 0;
    let number = parseFloat(value.toString().replace(this.props.decimalSeparator, '.'));
    let valueDecimals = value.toString().split(this.props.decimalSeparator)[1] ? value.toString().split(this.props.decimalSeparator)[1].length : 0;
    let stepDecimals = this.props.step.toString().split('.')[1] ? this.props.step.toString().split('.')[1].length : 0;
    if (valueDecimals > 0 || stepDecimals > 0) {
      let pow = Math.pow(10, valueDecimals > stepDecimals ? valueDecimals : stepDecimals);
      number = ((number * pow) - (this.props.step * pow)) / pow;
    } else {
      number -= this.props.step;
    }

    let result = this._setNumberResult({value: number.toString()});

    if (result.feedback === 'error') {
      this.setValue_(result.value, ()=> this._decreaseEnd());
    } else {
      this.setValue_(result.value);
    }
    return this;
  },

  _increase(){
    //TODO: optimize
    let value = this.state.value || 0;
    let number = parseFloat(value.toString().replace(this.props.decimalSeparator, '.'));
    let valueDecimals = value.toString().split(this.props.decimalSeparator)[1] ? value.toString().split(this.props.decimalSeparator)[1].length : 0;
    let stepDecimals = this.props.step.toString().split('.')[1] ? this.props.step.toString().split('.')[1].length : 0;
    if (valueDecimals > 0 || stepDecimals > 0) {
      let pow = Math.pow(10, valueDecimals > stepDecimals ? valueDecimals : stepDecimals);
      number = ((number * pow) + (this.props.step * pow)) / pow;
    } else {
      number += this.props.step;
    }

    let result = this._setNumberResult({value: number.toString()});

    if (result.feedback === 'error') {
      this.setValue_(result.value, ()=> this._increaseEnd());
    } else {
      this.setValue_(result.value);
    }
    return this;
  },

  _isDisabled(type) {
    let result = false;


    if (this.state.value) {
      let value = this.state.value || 0;
      let number = parseFloat(value.toString().replace(this.props.decimalSeparator, '.'));
      if (type === 'min' && this.props.min) {
        if (number <= this.props.min) {
          result = true
        }
      } else if (type === 'max' && this.props.max) {
        if (number >= this.props.max) {
          result = true
        }
      }
    }
    return result;
  },

  _increaseStart(){
    this._increaseTimer = setInterval(() => this._increase(), 100);
  },

  _increaseEnd(){
    this._increaseTimer && clearInterval(this._increaseTimer);
  },

  _decreaseStart(){
    this._decreaseTimer = setInterval(() => this._decrease(), 100);
  },

  _decreaseEnd(){
    this._decreaseTimer && clearInterval(this._decreaseTimer);
  },

  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render () {
    let inputId = this.getId() + '-input';
    let buttons = (!this.isReadOnly() && !this.props.buttonHidden) ? [{
      glyphicon: 'uu-glyphicon-minus',
      disabled: this.isDisabled() || this._isDisabled('min'),
      onClick: ()=> this._decrease(),
      colorSchema: 'default',
      mainAttrs: {onMouseDown: this._decreaseStart, onMouseUp: this._decreaseEnd, onMouseOut: this._decreaseEnd}
    },
      {
        glyphicon: 'uu-glyphicon-plus',
        disabled: this.isDisabled() || this._isDisabled('max'),
        onClick: ()=> this._increase(),
        colorSchema: 'default',
        mainAttrs: {onMouseDown: this._increaseStart, onMouseUp: this._increaseEnd, onMouseOut: this._increaseEnd}
      }] : null;

    return (
      <div {...this._getInputAttrs()}>
        {this.getLabel(inputId)}
        {this.getInputWrapper([
            <TextInput
              id={inputId}
              name={this.props.name || inputId}
              value={this.state.value ? this.state.value.toString() : ''}
              placeholder={this.props.placeholder}
              type='text'
              onChange={this._onChange}
              onBlur={this._onBlur}
              onFocus={this._onFocus}
              onKeyDown={this.onKeyDown}
              mainAttrs={this.props.inputAttrs}
              disabled={this.isDisabled() || this.isLoading()}
              readonly={this.isReadOnly()}
              glyphicon={this._getFeedbackIcon()}
              loading={this.isLoading()}
            />,

            <ItemList {...this._getItemListProps()}>
              {this._getChildren()}
            </ItemList>,
            <Backdrop {...this._getBackdropProps()} />],
          buttons)}
      </div>
    );
  }
  //@@viewOn:render
});

export default Number;



// WEBPACK FOOTER //
// ./forms/number.js